import { render, staticRenderFns } from "./AssignedUsers.vue?vue&type=template&id=62bdc31d&"
import script from "./AssignedUsers.vue?vue&type=script&lang=js&"
export * from "./AssignedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports